import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import {
  ParsedEvents,
  eventsService,
  ParsedProfession,
  professionsService,
  competencesService,
  MapedCompetencesType,
} from '@/services';
import { Providers, State } from './types';
import {
  INIT,
  FETCH_ITEM,
  SET_PROGRAM,
  FETCH_PROGRAM,
  SET_PROFESSION,
  SET_COMPETENCES,
  SET_NOTHING_FOUND,
  FETCH_COMPETENCES,
  FETCH_EMPLOYERS, SET_EMPLOYERS, SET_EDUCATION_ORGANIZATIONS, FETCH_EDUCATION_ORGANIZATIONS
} from "./consts";

const storeModule = ({ $api }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class ProfessionStore extends VuexModule<State, any> {
    profession: ParsedProfession = {
      id: '',
      name: '',
      image: '',
      main: {
        description: '',
        contraindicationsDesc: '',
        interestsDesc: '',
        qualitiesDesc: '',
      },
      sidebar: {
        paymentSize: '',
        workSphere: '',
        workType: '',
        profStandards: [],
        workPlace: [],
        payLevel: '',
        educationRequired: '',
        links: [],
      },
    };
    programs: ParsedEvents = [];
    employers: any = [];
    educationOrganizations: any = [];
    nothingFound: boolean = false;
    competences: MapedCompetencesType = [];

    @Mutation
    [SET_PROFESSION](data: any) {
      this.profession = data;
    }

    @Mutation
    [SET_PROGRAM](data: ParsedEvents) {
      this.programs = data;
    }

    @Mutation
    [SET_EMPLOYERS](data: ParsedEvents) {
      this.employers = data;
    }

    @Mutation
    [SET_EDUCATION_ORGANIZATIONS](data: ParsedEvents) {
      this.educationOrganizations = data;
    }

    @Mutation
    [SET_COMPETENCES](data: MapedCompetencesType) {
      this.competences = data;
    }

    @Mutation
    [SET_NOTHING_FOUND](payload: boolean) {
      this.nothingFound = payload;
    }

    @Action
    async [INIT](id: string) {
      const { commit, dispatch } = this.context;

      if (!id) return;

      try {
        await Promise.all([
          dispatch(FETCH_ITEM, id),
          dispatch(FETCH_PROGRAM, id),
          dispatch(FETCH_COMPETENCES, id),
          dispatch(FETCH_EMPLOYERS, id),
          dispatch(FETCH_EDUCATION_ORGANIZATIONS, id),
        ]);
      } catch (error) {
        const err: any = error;
        if (err && err.response && err.response.data) {
          commit(SET_NOTHING_FOUND, true);
        }
      }
    }

    @Action
    async [FETCH_ITEM](id: string) {
      const { commit } = this.context;

      try {
        const { data } = await professionsService($api).getProfession(id);
        commit(SET_PROFESSION, data);
      } catch (err) {}
    }

    @Action
    async [FETCH_PROGRAM](id: string) {
      const { commit } = this.context;

      try {
        const { data } = await eventsService($api).getEvents({
          profession: id,
        });
        commit(SET_PROGRAM, data);
      } catch (err) {
        commit(SET_PROGRAM, []);
      }
    }

    @Action
    async [FETCH_EMPLOYERS](id: string) {
      const { commit } = this.context;

      try {
        const { data } = await professionsService($api).getEmployers({
          profession: id,
          role: 2,
        });
        commit(SET_EMPLOYERS, data);
      } catch (err) {
        commit(SET_EMPLOYERS, []);
      }
    }

    @Action
    async [FETCH_EDUCATION_ORGANIZATIONS](id: string) {
      const { commit } = this.context;
      try {
        const { data } = await professionsService(
          $api
        ).getEducationOrganizations({
          profession: id,
          with_events: 1,
          role: 1,
        });
        commit(SET_EDUCATION_ORGANIZATIONS, data);
      } catch (err) {
        commit(SET_EDUCATION_ORGANIZATIONS, []);
      }
    }

    @Action
    async [FETCH_COMPETENCES](id: string) {
      const { commit } = this.context;

      try {
        const { data } = await competencesService($api).getCompetences({
          profession_id: id,
        });
        commit(SET_COMPETENCES, data);
      } catch (err) {
        commit(SET_COMPETENCES, []);
      }
    }
  }

  return ProfessionStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/professions/card/store.ts